import treatResponse from "./treat-response"
import { SERVER_LOCATION } from "../config"
import { getStoredUser } from "../services/auth"
import { SESSION_KWIKAPI_TOKEN } from "../config"

const api = {
    get: (url, options) => getAPI(url, options),
    post: (url, options) => postAPI(url, options),
    patch: (url, options) => patchAPI(url, options),
    delete: (url, options) => deleteAPI(url, options)
}

export const getEnterpriseId = () => {
    const user = getStoredUser()

    return (
        user?.profile?.enterprise?.id ||
        user?.profile?.enterprise?.pk ||
        user?.profile?.enterprise ||
        user?.enterprise?.id ||
        null
    )
}

const getAccessToken = () => localStorage.getItem(SESSION_KWIKAPI_TOKEN)

export const buildHeaders = (headers = {}) => {
	const token = getAccessToken()

	return {
		Authorization: token ? `Bearer ${token}` : '',
		'Content-Type': 'application/json',
		...headers,
	}
}

const getAPI = async (url, options) => {
    const response = await fetch(`${SERVER_LOCATION}/api/${url}`, {method: "GET",
		credentials: 'same-origin',
		headers: buildHeaders(),
        ...options
    })
    return await(treatResponse(response))
}

const postAPI = async (url, payload, options) => {
    const response = await fetch(`${SERVER_LOCATION}/api/${url}`, {method: "POST",
		credentials: 'same-origin',
		headers: buildHeaders(),
        body: JSON.stringify(payload),
        ...options
    })
    return await(treatResponse(response))
}

const patchAPI = async (url, payload, options) => {
    const response = await fetch(`${SERVER_LOCATION}/api/${url}`, {method: "PATCH",
		credentials: 'same-origin',
		headers: buildHeaders(),
        body: JSON.stringify(payload),
        ...options
    })
    return await(treatResponse(response))
}

const deleteAPI = async (url, options) => {
    const response = await fetch(`${SERVER_LOCATION}/api/${url}`, {method: "DELETE",
		credentials: 'same-origin',
		headers: buildHeaders(),
        ...options
    })
    return await(treatResponse(response))
}

export default api